import { useDisplay } from 'vuetify';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime.js';
import utc from 'dayjs/plugin/utc.js';
import timezone from 'dayjs/plugin/timezone.js';
import customParseFormat from 'dayjs/plugin/customParseFormat.js';

export function isMobile() {
  const { xs, sm } = useDisplay();
  return xs.value || sm.value;
}

dayjs.extend(relativeTime);
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);
dayjs.locale('pt-br');
export const $dayjs = dayjs;

export type {
  GuestInterface,
  RecipientInterface,
  SchedulingInterface,
  DeliveryInterface,
} from 'assets-global/src';
export * as ast from 'assets-global/src';
export * as frt from 'front-global/src';
